(function(){
  'use strict';

  if (window.__tangibleSizeRuntimeV6) return;
  window.__tangibleSizeRuntimeV6 = true;

  var nativeAppendChild = Node.prototype.appendChild;

  Node.prototype.appendChild = function(child){
    var isStableSizeGrid = this &&
      this.nodeType === 1 &&
      this.classList &&
      this.classList.contains('tg-size-grid') &&
      child &&
      child.parentNode === this;

    if (isStableSizeGrid) return child;
    return nativeAppendChild.call(this, child);
  };

  function selectedInput(field){
    return field ? field.querySelector('input.product-form__radio:checked') : null;
  }

  function syncHeading(field){
    if (!field) return;
    var input = selectedInput(field);
    var output = field.querySelector(':scope > .tg-size-heading .tg-size-title-value');
    if (input && output && output.textContent.trim() !== input.value) output.textContent = input.value;
  }

  function findInput(field, label){
    var id = label.htmlFor || label.getAttribute('for');
    if (!id) return null;
    var input = document.getElementById(id);
    return input && field.contains(input) ? input : null;
  }

  function activateSize(event){
    if (!event.target || !event.target.closest) return;

    var label = event.target.closest('fieldset.tg-native-size-option > .tg-size-grid > label.product-form__label');
    if (!label) return;

    var field = label.closest('fieldset.tg-native-size-option');
    var input = findInput(field, label);
    if (!field || !input || input.disabled) return;

    event.preventDefault();

    if (!input.checked) {
      input.checked = true;
      syncHeading(field);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      syncHeading(field);
    }
  }

  function compact(value){
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function conciseColour(value){
    var clean = compact(value).replace(/^(?:\s*colou?r\s*:?\s*)+/i, '').replace(/^:+\s*/, '').trim();
    var percentage = clean.search(/\s+\d{1,3}%(?:\s|$)/);
    var material = clean.search(/\s+(?:pure\s+)?(?:cotton|linen|polyester|viscose|rayon|slub|oxford|satin|dobby|jacquard|spandex)\b/i);
    if (percentage > 0) clean = clean.slice(0, percentage).trim();
    else if (material > 0) clean = clean.slice(0, material).trim();
    return clean;
  }

  function currentProductColour(){
    var title = document.querySelector(
      'main#MainContent h1.productView-title, main#MainContent .product__title h1, main#MainContent h1'
    );
    var titleText = compact(title && title.textContent);
    if (!titleText) {
      titleText = compact(document.title).replace(/\s+[–—-]\s+Tangible.*$/i, '');
    }
    return titleText.split(/\s+/).slice(0, 2).join(' ');
  }

  function syncActiveSwatch(cleanName){
    var active = document.querySelector(
      'main#MainContent .globo-product-groups-detail a.is-gsw-active, main#MainContent .globo-product-groups-detail a[aria-current="page"]'
    );
    if (!active || !cleanName) return;
    if (active.getAttribute('title') !== cleanName) active.setAttribute('title', cleanName);
    if (active.getAttribute('aria-label') !== cleanName) active.setAttribute('aria-label', cleanName);
    if (active.getAttribute('aria-current') !== 'page') active.setAttribute('aria-current', 'page');
    if (active.parentElement) active.parentElement.classList.add('tg-point7-current');
  }

  function normalizeColourLegend(legend){
    if (!legend) return;

    var name = legend.querySelector('.name');
    var cleanName = currentProductColour() ||
      conciseColour(name && name.textContent) ||
      conciseColour(legend.textContent);
    if (!cleanName) return;

    if (name && compact(name.textContent) !== cleanName) name.textContent = cleanName;

    var finalHeading = legend.querySelector(':scope > .tg-colour-final');
    if (!finalHeading) {
      finalHeading = document.createElement('span');
      finalHeading.className = 'tg-colour-final';
      legend.appendChild(finalHeading);
    }

    var finalText = 'Colour: ' + cleanName;
    if (compact(finalHeading.textContent) !== finalText) finalHeading.textContent = finalText;
    finalHeading.removeAttribute('aria-hidden');
    syncActiveSwatch(cleanName);

    legend.classList.add('tg-colour-finalized');
    legend.setAttribute('aria-label', finalText);
    legend.setAttribute('data-tg-point7-active', cleanName);
    legend.setAttribute('data-tg-colour-source', 'product-title');
    legend.setAttribute('data-tg-colour-prefix-count', '1');
    legend.setAttribute('data-tg-colour-heading', finalText);
    legend.setAttribute('data-tg-colour-verified', compact(finalHeading.textContent) === finalText ? 'true' : 'false');
  }

  function normalizeColourHeadings(){
    document.querySelectorAll('main#MainContent .globo-product-groups-detail legend').forEach(normalizeColourLegend);
  }

  var colourQueued = false;
  function scheduleColourNormalization(){
    if (colourQueued) return;
    colourQueued = true;
    requestAnimationFrame(function(){
      colourQueued = false;
      normalizeColourHeadings();
    });
  }

  function startColourNormalization(){
    normalizeColourHeadings();
    [80, 250, 700, 1500].forEach(function(delay){
      setTimeout(normalizeColourHeadings, delay);
    });

    function handleGloboUpdate(event){
      if (!event.target || !event.target.closest || !event.target.closest('.globo-product-groups-detail')) return;
      scheduleColourNormalization();
    }

    document.addEventListener('click', handleGloboUpdate, true);
    document.addEventListener('change', handleGloboUpdate, true);
    document.addEventListener('shopify:section:load', scheduleColourNormalization);
  }

  document.addEventListener('click', activateSize, true);
  document.addEventListener('change', function(event){
    if (!event.target || !event.target.matches('fieldset.tg-native-size-option input.product-form__radio')) return;
    var field = event.target.closest('fieldset.tg-native-size-option');
    syncHeading(field);
    setTimeout(function(){ syncHeading(field); }, 0);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startColourNormalization, { once: true });
  } else {
    startColourNormalization();
  }
})();

(function () {
  'use strict';

  if (window.__tangiblePdpSizeRequiredV1) return;
  window.__tangiblePdpSizeRequiredV1 = true;

  var state = {
    selectedSize: '',
    userIntent: false,
    queued: false
  };

  function compact(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function sizeScore(field) {
    if (!field) return 0;
    var legend = compact(field.querySelector('legend') && field.querySelector('legend').textContent);
    if (/\bsize\b/i.test(legend)) return 100;
    var values = Array.prototype.map.call(
      field.querySelectorAll('input.product-form__radio'),
      function (input) { return compact(input.value).toUpperCase(); }
    );
    return values.filter(function (value) {
      return /^(?:XS|S|M|L|XL|XXL|XXXL|[2-6]XL)$/.test(value);
    }).length;
  }

  function sizeFields() {
    return Array.prototype.filter.call(
      document.querySelectorAll('main#MainContent fieldset.product-form__input'),
      function (field) { return sizeScore(field) >= 3; }
    );
  }

  function primaryField() {
    var fields = sizeFields();
    return fields.find(function (field) {
      return field.classList.contains('tg-native-size-option') &&
        !field.classList.contains('mobile');
    }) || fields.find(function (field) {
      return !field.classList.contains('mobile');
    }) || fields[0] || null;
  }

  function setNativeHeading(field, value) {
    var nativeValue = field && field.querySelector('legend [data-header-option]');
    if (nativeValue && compact(nativeValue.textContent) !== value) nativeValue.textContent = value;
  }

  function renderHeading(field, value) {
    if (!field) return;
    setNativeHeading(field, value);

    var title = field.querySelector(':scope > .tg-size-heading .tg-size-title');
    if (!title) return;

    var output = title.querySelector('.tg-size-title-value');
    var first = title.firstChild;
    var prefix = value ? 'Size: ' : 'Size';

    if (!first || first.nodeType !== 3) {
      first = document.createTextNode(prefix);
      title.insertBefore(first, title.firstChild);
    } else if (first.nodeValue !== prefix) {
      first.nodeValue = prefix;
    }

    if (output && compact(output.textContent) !== value) output.textContent = value;
  }

  function renderAllHeadings(value) {
    sizeFields().forEach(function (field) { renderHeading(field, value); });
  }

  function clearDefaultSelections() {
    if (state.selectedSize) return;
    sizeFields().forEach(function (field) {
      field.querySelectorAll('input.product-form__radio:checked').forEach(function (input) {
        input.checked = false;
        input.removeAttribute('checked');
      });
      renderHeading(field, '');
    });
  }

  function errorNode(field) {
    if (!field) return null;
    var error = field.querySelector(':scope > .tg-size-required-error');
    if (error) return error;

    error = document.createElement('p');
    error.className = 'tg-size-required-error';
    error.id = 'tg-size-required-error';
    error.setAttribute('role', 'alert');
    error.hidden = true;
    error.innerHTML = '<span class="tg-size-required-error__icon" aria-hidden="true">!</span><span>Please select a size to continue.</span>';
    field.appendChild(error);
    return error;
  }

  function clearError() {
    var field = primaryField();
    if (!field) return;
    var error = errorNode(field);
    field.classList.remove('tg-size-required-invalid');
    field.removeAttribute('aria-invalid');
    field.removeAttribute('aria-describedby');
    if (error) error.hidden = true;
  }

  function showError() {
    var field = primaryField();
    if (!field) return;
    var error = errorNode(field);
    field.classList.add('tg-size-required-field', 'tg-size-required-invalid');
    field.setAttribute('aria-invalid', 'true');
    field.setAttribute('aria-describedby', error.id);
    error.hidden = false;
    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function syncFields(value) {
    sizeFields().forEach(function (field) {
      field.querySelectorAll('input.product-form__radio').forEach(function (input) {
        input.checked = compact(input.value) === value;
      });
      renderHeading(field, value);
    });
  }

  function acceptSelection(input) {
    var value = compact(input && input.value);
    if (!value) return;
    state.selectedSize = value;
    syncFields(value);
    clearError();
    document.body.setAttribute('data-tg-selected-size', value);
  }

  function inputForLabel(label) {
    if (!label) return null;
    var id = label.htmlFor || label.getAttribute('for');
    if (!id) return null;
    var input = document.getElementById(id);
    return input && input.matches('input.product-form__radio') ? input : null;
  }

  function isPrimaryPurchaseControl(node) {
    if (!node || !node.closest) return null;
    var control = node.closest([
      'button.product-form__submit',
      'button[name="add"]',
      '.shopify-payment-button__button--unbranded',
      '[data-shopify="payment-button"] button',
      'button[data-btn-addtocart]',
      'button[data-btn-addToCart]'
    ].join(','));
    if (!control || control.closest('.tangible-qa-v2-modal')) return null;
    return control.closest('.productView, [id^="ProductSection-"], .productView-stickyCart') ? control : null;
  }

  function onWindowClick(event) {
    if (!document.body.classList.contains('template-product')) return;

    var label = event.target && event.target.closest &&
      event.target.closest('fieldset.product-form__input label.product-form__label');
    var input = inputForLabel(label);
    if (input && sizeScore(input.closest('fieldset')) >= 3 && !input.disabled) {
      state.userIntent = true;
      window.setTimeout(function () { state.userIntent = false; }, 0);
    }

    var purchase = isPrimaryPurchaseControl(event.target);
    if (!purchase || state.selectedSize) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    showError();
  }

  function onChange(event) {
    var input = event.target;
    if (!input || !input.matches('input.product-form__radio')) return;
    if (sizeScore(input.closest('fieldset')) < 3) return;

    if (state.userIntent || event.isTrusted) acceptSelection(input);
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.matches('form')) return;
    if (!form.closest('.productView, [id^="ProductSection-"], .productView-stickyCart')) return;
    if (state.selectedSize) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    showError();
  }

  function run() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    var field = primaryField();
    if (!field) return;
    field.classList.add('tg-size-required-field');
    errorNode(field);
    if (state.selectedSize) renderAllHeadings(state.selectedSize);
    else clearDefaultSelections();
  }

  function schedule() {
    if (state.queued) return;
    state.queued = true;
    requestAnimationFrame(function () {
      state.queued = false;
      run();
    });
  }

  function start() {
    run();
    [80, 250, 700, 1500].forEach(function (delay) {
      window.setTimeout(run, delay);
    });
  }

  window.addEventListener('click', onWindowClick, true);
  window.addEventListener('submit', onSubmit, true);
  document.addEventListener('change', onChange, true);
  document.addEventListener('shopify:section:load', function () {
    state.selectedSize = '';
    document.body.removeAttribute('data-tg-selected-size');
    window.setTimeout(run, 50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
